module.exports = __webpack_public_path__ + "static/img/gitf_pack_baner.8c8e92b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/claim/gitf_pack_baner.png
// module id = M74v
// module chunks = 1